<template>
	<div class="order_cancel_box" v-if="showDialog">
		<div class="oc_mainbox">
			<div class="oc_top_title">
				{{ title }}
				<div class="close_login" @click="_Cancel">
					<span></span>
				</div>
			</div>
			<div class="oc_sure_textbox">
				<slot name="content"></slot>
			</div>
			<div class="oc_sure_btnbox">
				<el-button type="primary" class="oc_sure" @click="_Confirm">确认</el-button>
				<el-button type="primary" plain class="oc_exit" @click="_Cancel">取消</el-button>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		confirm: {
			type: Function,
			default: null,
		},
		cancel: {
			type: Function,
			default: null,
		},
	},
	data() {
		return {
			title: "提示",
			showDialog: false,
		};
	},
	methods: {
		show() {
			this.showDialog = true;
		},
		hide() {
			this.showDialog = false;
		},
		_Confirm() {
			if (this.confirm) {
				this.confirm();
			}
			this.hide();
		},
		_Cancel() {
			if (this.cancel) this.cancel();
			this.hide();
		},
	},
};
</script>
<style lang="scss">
.order_cancel_box {
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 3333;

	.oc_mainbox {
		height: 280px;
		width: 420px;
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		margin: auto;
		padding-bottom: 70px;
		background: #ffffff;
		border-radius: 10px;
		overflow: hidden;
		text-align: center;

		.oc_top_color {
			background: #d86556;
			height: 3px;
		}

		.oc_top_title {
			color: #ffffff;
			background: #1483d1;
			line-height: 45px;
			position: relative;
			font-size: 16px;
			text-indent: 20px;
			text-align: left;

			// &::after {
			// 	content: "";
			// 	position: absolute;
			// 	top: 0;
			// 	left: 50%;
			// 	transform: translateX(-50%);
			// 	background-image: url("../../static/img/white_shadow.png");
			// 	width: 216px;
			// 	height: 29px;
			// 	background-size: cover;
			// }
		}
	}

	.oc_mainbox p {
		text-align: center;
		color: #333;
		line-height: 24px;
		// font-weight: bold;
		font-weight: 400;
	}

	.oc_sure_textbox {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 100%;
		padding-bottom: 45px; /*减去头部高度*/
		font-size: 16px;
	}

	.oc_sure_btnbox {
		position: absolute;
		bottom: 0;
		padding: 10px 0 20px;
		display: flex;
		justify-content: center;
		width: 100%;
		overflow: hidden;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Elasticframe/OrderCancel.vue